export const firebaseConfig = {
    apiKey: "AIzaSyCJ7DLBntXHYdsX2EkLFX19ogvwe7lcq9g",
    authDomain: "edelsteineinformationen.firebaseapp.com",
    projectId: "edelsteineinformationen",
    storageBucket: "edelsteineinformationen.appspot.com",
    messagingSenderId: "784437932102",
    appId: "1:784437932102:web:7945a6d4a8f403186e5a47",
    measurementId: "G-E08C944VG0"
};